import UrlConst from '../../constants/UrlConst';

import apiClient from '../common/apiClient';
import { makeEndpoint, makeGetRequestSettings } from '../common/utils';

export interface IProduct {
    id: number;
    name: string;
    description?: string;
    tags?: string[];
}

export const makeProductsUrl = (suffix: string = '', params = {}) => {
    return makeEndpoint(UrlConst.REGISTERS_URL, '/products' + suffix, {
        ...params,
    });
};

export const restGetProducts = (): Promise<IProduct[]> =>
    apiClient.send(makeGetRequestSettings(makeProductsUrl('')));
